<template>
  <div id="app">
    <router-view />
    <u-dialog :message="message"
              :visible.sync="visible"
              :title="title"
              :onConfirm="onConfirm"
              :onClose="onClose"
              closeButton
              confirmButton
              confirmText="确认"
              closeText="取消" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      message: state => state.app.message.message,
      title: state => state.app.message.title,
      onConfirm: state => state.app.message.onConfirm,
      onClose: state => state.app.message.onClose,
    }),
    visible: {
      get() {
        return this.$store.state.app.message.visible
      },
      set({ visible }) {
        this.$store.commit('showMsgBox', visible)
      },
    },
  }
}
</script>

<style lang="scss">
@import './styles/index.scss';
</style>
